import { app } from '../app';

class PublicServiceResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getAllWithEpmSupportFiltered() {
        const url = 'app/rest/public_services/epmsupported';
        return this.$http.get(url).then(({data}) => data);
    }
}

app.service('PublicServiceResource', PublicServiceResource);



// WEBPACK FOOTER //
// ./src/portal/rest/PublicServiceResource.js